import YubikeyCard from './YubikeyCard';

export default YubikeyCard;
